import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import SimpleBar from 'simplebar-react';

const SideBar = ({ handleToggle, toggled, hovered, setHovered }) => {

    const [hasDrop, setHasdrop] = useState(false);

    const togglehasDrop = () => {
        setHasdrop(!hasDrop);
    }

    return (
        <>
            <div className="sidebar-wrapper" data-simplebar="true"
                onMouseEnter={() => toggled && setHovered(true)}
                onMouseLeave={() => toggled && setHovered(false)}
            >
                <div className="sidebar-header">
                    <div>
                        <img src="images/logo.png" className="logo-icon logo_dark" alt="logo icon" />
                        <img src="images/logo.png" className="logo-icon logo_light" alt="logo icon" />
                    </div>
                    <div className="toggle-icon ms-auto" onClick={handleToggle}><i className="bx bx-menu" />
                    </div>
                </div>
                <SimpleBar style={{ maxHeight: "100%" }}>
                    <ul className="metismenu" id="menu">
                        <li>
                            <Link to="/">
                                <div className="parent-icon"><i className="bx bx-home" /></div>
                                <div className="menu-title">Dashboard</div>
                            </Link>
                        </li>
                         <li>
                            <Link to="/user-management">
                                <div className="parent-icon"><i className="bx bx-user-circle" /></div>
                                <div className="menu-title">User Management</div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/reported-profiles">
                                <div className="parent-icon"><i className="bx bx-flag" /></div>
                                <div className="menu-title">Reported Profiles</div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/payment-history">
                                <div className="parent-icon"><i className="bx bx-credit-card" /></div>
                                <div className="menu-title">financials</div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/support-ticket">
                                <div className="parent-icon"><i className="bx bx-support" /></div>
                                <div className="menu-title">Support Tickets</div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/static-content">
                                <div className="parent-icon"><i className="bx bx-file" /></div>
                                <div className="menu-title">Static Content</div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/notifications">
                                <div className="parent-icon"><i className="bx bxs-bell" /></div>
                                <div className="menu-title">Admin Notification</div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/settings">
                                <div className="parent-icon"><i className="bx bx-cog" /></div>
                                <div className="menu-title">Settings</div>
                            </Link>
                        </li>
                    </ul>
                    <div className="sidebar-logout">
                        <ul>
                            <li>
                                <Link data-bs-toggle="modal" data-bs-target="#logoutModal" className="d-flex align-content-center">
                                    <div className="parent-icon">
                                        <i className="bx bx-log-out" />
                                    </div>
                                    <div className="menu-title">Logout</div>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </SimpleBar>
            </div >
        </>
    )
}

export default SideBar